import type { ClipboardEvent } from 'react'

export const SUPPLIER_ACCOUNT_MOBILE_PATTERN = /^1[3-9]\d{9}$/
export const SUPPLIER_ACCOUNT_MOBILE_INVALID = '请输入正确的11位手机号'

export const normalizeSupplierAccountMobile = (mobile?: string) =>
  (mobile || '').trim()

export const getSupplierAccountMobileRule = () => ({
  validator: (_: unknown, mobile?: string) => {
    const normalized = normalizeSupplierAccountMobile(mobile)
    if (!normalized) return Promise.reject(new Error('请输入手机号'))
    if (!SUPPLIER_ACCOUNT_MOBILE_PATTERN.test(normalized)) {
      return Promise.reject(new Error(SUPPLIER_ACCOUNT_MOBILE_INVALID))
    }
    return Promise.resolve()
  },
})

export const rejectOversizeSupplierAccountMobilePaste = (
  event: ClipboardEvent<HTMLInputElement>,
) => {
  const input = event.currentTarget
  const start = input.selectionStart ?? input.value.length
  const end = input.selectionEnd ?? start
  const pastedText = event.clipboardData.getData('text')
  const nextValue = `${input.value.slice(0, start)}${pastedText}${input.value.slice(end)}`
  if (nextValue.length <= 11) return false
  event.preventDefault()
  return true
}

export const SUPPLIER_ACCOUNT_REAL_NAME_PATTERN =
  /^[\u4e00-\u9fa5A-Za-z ·-]+$/
import type { ClipboardEvent } from 'react'

export const SUPPLIER_ACCOUNT_MOBILE_PATTERN = /^1[3-9]\d{9}$/
export const SUPPLIER_ACCOUNT_MOBILE_INVALID = '请输入正确的11位手机号'

export const normalizeSupplierAccountMobile = (mobile?: string) =>
  (mobile || '').trim()

export const getSupplierAccountMobileRule = () => ({
  validator: (_: unknown, mobile?: string) => {
    const normalized = normalizeSupplierAccountMobile(mobile)
    if (!normalized) return Promise.reject(new Error('请输入手机号'))
    if (!SUPPLIER_ACCOUNT_MOBILE_PATTERN.test(normalized)) {
      return Promise.reject(new Error(SUPPLIER_ACCOUNT_MOBILE_INVALID))
    }
    return Promise.resolve()
  },
})

export const rejectOversizeSupplierAccountMobilePaste = (
  event: ClipboardEvent<HTMLInputElement>,
) => {
  const input = event.currentTarget
  const start = input.selectionStart ?? input.value.length
  const end = input.selectionEnd ?? start
  const pastedText = event.clipboardData.getData('text')
  const nextValue = `${input.value.slice(0, start)}${pastedText}${input.value.slice(end)}`
  if (nextValue.length <= 11) return false
  event.preventDefault()
  return true
}

export const SUPPLIER_ACCOUNT_REAL_NAME_PATTERN =
  /^[\u4e00-\u9fa5A-Za-z ·-]+$/
